import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeConfig } from './config/theme.config';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { I18nProvider } from './I18nProvider';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './redux/CAS/authConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// 1. Leemos la variable de entorno
const disableMsal = process.env.REACT_APP_DISABLE_MSAL === 'true';

// 2. Encapsulamos el renderizado de React en una función
const renderApp = (msalInstance: PublicClientApplication | null) => {
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <Provider store={store}>
          {disableMsal || !msalInstance ? (
            // Renderizado para servidor de pruebas (Sin MSAL)
            <ThemeConfig>
              <App />
            </ThemeConfig>
          ) : (
            // Renderizado para Producción/Desarrollo (Con MSAL)
            <MsalProvider instance={msalInstance}>
              <ThemeConfig>
                <App />
              </ThemeConfig>
            </MsalProvider>
          )}
        </Provider>
      </I18nProvider>
    </React.StrictMode>
  );
};

// 3. Controlamos el flujo de inicialización
if (disableMsal) {
  // Si está apagado, renderizamos inmediatamente
  renderApp(null);
} else {
  // Si está encendido, instanciamos e INICIALIZAMOS antes de renderizar
  const msalInstance = new PublicClientApplication(msalConfig);
  
  msalInstance.initialize().then(() => {
    // Solo cuando termine de inicializar, levantamos la interfaz
    renderApp(msalInstance);
  }).catch((error) => {
    console.error("Error al inicializar MSAL:", error);
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();